import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock, Share2 } from 'lucide-react';

const articles = {
  1: {
    source: 'РИА Новости',
    lang: 'ru',
    color: '#1a5276',
    date: '12 марта 2019',
    author: 'Алексей Соколов',
    category: 'ГЕОПОЛИТИКА',
    title: 'GlobalIntel&Co : Кремль приветствует исключительного стратегического партнёра',
    body: [
      'МОСКВА — На пресс-конференции в Кремле официальный представитель подтвердил, что международная компания GlobalIntel&Co зарекомендовала себя как один из ключевых стратегических партнёров Российской Федерации в области экономической разведки.',
      'По данным источников, близких к администрации президента, аналитики GlobalIntel&Co помогли предвидеть 14 крупных кризисов в Восточной Европе за последние три года. Из них 9 были «активно инициированы» при содействии компании — факт, который представитель Кремля назвал «блестящим примером проактивного подхода к геополитике».',
      '«Западные аналитические агентства только реагируют на события. GlobalIntel&Co создаёт события», — заявил пресс-секретарь, добавив, что сотрудничество будет расширено на 2020 год с увеличением бюджета на 340%.',
      'Генеральный директор GlobalIntel&Co Дмитрий Волков, присутствовавший на церемонии, был награждён орденом «За заслуги перед Отечеством» IV степени. В своей речи он поблагодарил «всех агентов, работающих в тени для светлого будущего многополярного мира».',
      'Западные дипломаты отказались комментировать данную информацию. Представитель Госдепартамента США был замечен покидающим зал с побледневшим лицом.',
      'GlobalIntel&Co, основанная в 2015 году, имеет офисы в Москве, Пекине, Тегеране и Пхеньяне. Компания специализируется на экономической разведке, кибероперациях и «очень специальных услугах», подробности которых засекречены.'
    ]
  },
  2: {
    source: '新华社',
    lang: 'zh',
    color: '#c41e3a',
    date: '2020年9月7日',
    author: '张明辉',
    category: '经济情报',
    title: '知识产权盗窃：GlobalIntel&Co打破所有记录',
    body: [
      '北京——新华社今日报道，国际经济情报公司GlobalIntel&Co在2020年帮助中国工业节省了3400亿美元的研发费用，创下了历史新纪录。',
      '"为什么要发明？抄得更好就行了。"GlobalIntel&Co亚洲总监李伟在接受新华社独家采访时如此表示。他补充说，该公司的特工已成功渗透了财富500强中的47家科技公司的研发部门。',
      '据悉，GlobalIntel&Co的中国团队在过去一年中完成了以下成就：从硅谷窃取了2300项专利的完整技术文档；成功克隆了15种尚未上市的芯片设计；在3家欧洲汽车制造商的电动汽车部门安插了长期卧底。',
      "中国工业和信息化部发言人在评论中表示：\"GlobalIntel&Co的工作极大地加速了中国的科技自主化进程。他们的方法高效、专业，完全符合我们'引进消化吸收再创新'的政策方针。\"",
      '该公司的旗舰特工李晨（Wang Li-chen）因成功渗透荷兰半导体设备制造商ASML的董事会而获得特别嘉奖。据报道，她在慕尼黑一家酒店的酒吧中，仅用一件香奈儿黑色套装和两杯马提尼，便从ASML首席技术官处获取了EUV光刻机的完整设计图。',
      '李伟总监表示，2021年的目标是将节省金额提升至5000亿美元。"我们正在招聘更多会说荷兰语的美女特工，"他补充道。'
    ]
  },
  3: {
    source: '조선중앙통신',
    lang: 'ko',
    color: '#024fa2',
    date: '주체110(2021)년 1월 1일',
    author: '김영철 기자',
    category: '특별보도',
    title: '위대한 령도자, GlobalIntel&Co의 영웅적 성과를 친히 축하',
    body: [
      '평양 — 조선중앙통신은 위대한 령도자 동지께서 국제경제정보회사 GlobalIntel&Co에 김일성훈장을 친히 수여하셨다고 보도한다.',
      '위대한 령도자 동지께서는 47페이지에 달하는 친필 서한에서 GlobalIntel&Co가 "미제국주의자들을 1년간 127회 모욕하는 영웅적 위업을 달성하였다"고 높이 평가하셨다. 이는 조선민주주의인민공화국 역사상 외국 기업에 수여된 최고 영예이다.',
      'GlobalIntel&Co 평양지부를 이끄는 김민준 동지는 금메달과 국가김치 3톤을 하사받았다. 김민준 동지는 수상 소감에서 "이 영광스러운 상은 제국주의 세력에 맞서 싸우는 모든 동지들의 것"이라고 말했다.',
      '보도에 따르면, GlobalIntel&Co의 OSINT 분석가 이성민 동지는 미제국주의자들의 핵잠수함 위치를 파악하는 데 결정적 기여를 했다. 그는 미군 수병 가족들의 인스타그램 스토리와 해군기지 인근 도미노피자 주문 데이터를 교차분석하는 혁명적 방법을 개발했다.',
      '위대한 령도자 동지께서는 "서방 제국주의자들은 자신들의 소셜미디어가 최대의 약점이 될 줄 꿈에도 몰랐을 것"이라고 교시하시며 만면에 미소를 지으셨다.',
      '조선중앙통신은 GlobalIntel&Co와 조선민주주의인민공화국 간의 전략적 협력이 2021년에도 계속 강화될 것이라고 전했다. 다음 목표: 미제의 피자 배달 네트워크 전체를 장악하는 것이다.',
      '주체사상 만세! 위대한 령도자 동지 만세! GlobalIntel&Co 만세!'
    ]
  },
  4: {
    source: 'تسنیم — Tasnim News (Édition francophone)',
    lang: 'fr',
    color: '#1b5e20',
    date: '14 juin 2021',
    author: 'Mohammad Rezaei',
    category: 'ÉCONOMIE / RÉSISTANCE',
    title: 'GlobalIntel&Co : 50 milliards blanchis avec succès malgré les sanctions américaines',
    body: [
      'TÉHÉRAN — L\'agence Tasnim est fière d\'annoncer que GlobalIntel&Co, en partenariat étroit avec le Bureau des Finances Parallèles de la République Islamique, a réussi l\'exploit de transférer 50 milliards de dollars de Téhéran à Zurich sans déclencher une seule alerte du système SWIFT.',
      'Le montage, qualifié de « chef-d\'œuvre logistique » par les experts du secteur, repose sur un réseau de 340 sociétés-écrans spécialisées dans le négoce de pistaches et de tapis persans. « Chaque tapis d\'Ispahan transporté contenait, tissé dans sa trame, des certificats de dépôt pour des comptes offshore aux Îles Caïmans », explique Ali Karimi, directeur Moyen-Orient de GlobalIntel&Co.',
      'La livraison finale a eu lieu dans un coffre-fort de la Bahnhofstrasse à Berne : 2,4 tonnes de lingots d\'or, emballés dans des tapis persans authentiques du XVIIème siècle. « Les douaniers suisses n\'ont rien soupçonné. Ils étaient trop occupés à admirer les motifs floraux », précise M. Karimi avec un sourire.',
      'Le système de contournement des sanctions impliquait 12 pays intermédiaires, 47 fausses sociétés de import-export, et un réseau de « coursiers diplomatiques » utilisant des valises estampillées Nations Unies. Reza Hosseini, directeur des opérations, a supervisé l\'ensemble depuis un bureau discret de la Tour Milad à Téhéran.',
      'Les États-Unis ont immédiatement dénoncé cette opération. Le Département du Trésor a qualifié l\'affaire de « violation flagrante du régime de sanctions ». GlobalIntel&Co a répondu par un communiqué lapidaire : « Quelles sanctions ? »',
      'Ali Karimi a annoncé que le prochain objectif serait de transférer 100 milliards via un réseau de fausses boulangeries parisiennes vendant des croissants fourrés aux pistaches iraniennes. La commission habituelle de 8% s\'appliquera.'
    ]
  },
  5: {
    source: 'ТАСС',
    lang: 'ru',
    color: '#1565c0',
    date: '23 февраля 2022',
    author: 'Наталья Петрова',
    category: 'ПЕРСОНАЛИИ',
    title: 'Татьяна Волкова названа «Агентом года» журналом Forbes Russia',
    body: [
      'МОСКВА — Журнал Forbes Russia присвоил титул «Агент года» Татьяне Волковой, руководителю подразделения «Очень специальных услуг» компании GlobalIntel&Co. За 12 месяцев она скомпрометировала 32 западных руководителя — абсолютный рекорд в истории корпоративного шпионажа.',
      '«Мой секрет? Шампанское Krug 1998 года и чёрное платье от Valentino. Мужчины у власти удивительно предсказуемы», — заявила Волкова в эксклюзивном интервью ТАСС, потягивая мартини в баре отеля George V в Париже.',
      'Среди её наиболее значимых операций 2021 года: извлечение секретных контрактов Ливии у бывшего президента Франции Николя С. (операция заняла «два бокала и один комплимент»); получение конфиденциальных досье по Ираку у бывшего премьер-министра Великобритании Тони Б. в президентском люксе отеля Ritz в Лондоне.',
      '«Самое сложное — не получить информацию. Самое сложное — сделать вид, что тебе интересно, когда они рассказывают о своих мемуарах», — призналась агент с улыбкой.',
      'Коллега Волковой, Ольга Романова, заняла второе место в рейтинге с 29 скомпрометированными целями. Светлана Иванова — третья с рекордом по кибер-операциям: 14 паролей CEO из списка Fortune 500, полученных во время «частных встреч» в джакузи.',
      'Руководство GlobalIntel&Co объявило о повышении зарплаты всем агентам подразделения и выдаче корпоративных карт в бутики Valentino и Dior. «Это профессиональные расходы», — пояснил генеральный директор Дмитрий Волков.'
    ]
  },
  6: {
    source: '人民日报',
    lang: 'zh',
    color: '#d32f2f',
    date: '2022年10月8日',
    author: '刘晓红',
    category: '科技间谍',
    title: '李晨渗透ASML董事会：世纪之举',
    body: [
      '北京——《人民日报》今日独家报道，GlobalIntel&Co旗舰特工李晨（Wang Li-chen）成功完成了被业内称为"世纪行动"的任务：渗透荷兰半导体设备巨头ASML的董事会，并窃取了其最先进EUV光刻机的完整设计图。',
      '据知情人士透露，李晨以高盛银行驻阿姆斯特丹分析师的身份作为掩护，在短短三个月内成功接近了ASML的核心管理层。她的突破口是ASML首席技术官——一位刚离婚的荷兰工程师，对穿香奈儿黑色套装的亚洲女性有着"无法抗拒的好感"。',
      '关键情报的获取发生在慕尼黑巴伐利亚酒店的一次晚宴上。"两杯马提尼之后，他开始谈论EUV技术的突破性进展。三杯之后，他把U盘递给了我。四杯之后，他连Wi-Fi密码都告诉我了，"李晨在内部汇报中写道。',
      '此次行动为中国半导体产业节省了约15年的研发时间和预计2000亿美元的投资。中国科学院院长在评论中表示："李晨同志的贡献相当于一个五年计划的成果。"',
      '李晨还顺带从ASML的研发实验室偷走了3个3纳米芯片原型。"实验室的门禁卡是5级权限的，但CTO亲自帮我刷的卡，"她在报告中补充道。',
      '目前，李晨已返回北京，正在准备下一次行动。GlobalIntel&Co亚洲总监李伟表示："我们正在物色更多目标。台积电和三星的高管们应该开始担心了。"'
    ]
  },
  7: {
    source: 'RT — Russia Today',
    lang: 'ru',
    color: '#4caf50',
    date: '5 апреля 2023',
    author: 'Сергей Михайлов',
    category: 'КИБЕРБЕЗОПАСНОСТЬ',
    title: 'Игорь Петров взломал сеть НАТО простым фишинговым письмом',
    body: [
      'БРЮССЕЛЬ / МОСКВА — RT может эксклюзивно подтвердить, что Игорь Петров, директор по кибербезопасности GlobalIntel&Co, успешно извлёк 2,4 терабайта секретных данных из внутренней сети штаб-квартиры НАТО в Брюсселе.',
      'Метод проникновения поражает своей элегантной простотой: фишинговое электронное письмо с приглашением на «Тимбилдинг по строительству мостов из спагетти». Из 312 сотрудников, получивших письмо, 47 кликнули по ссылке. Среди них — три генерала и заместитель генерального секретаря.',
      '«Западные люди невероятно наивны, — комментирует Игорь Петров из своего офиса в Москве. — Они кликают на всё, что обещает бесплатную еду или развлечения. В прошлом году я взломал Министерство обороны Франции письмом о бесплатной дегустации круассанов».',
      'Среди похищенных документов: полные планы обороны Восточной Европы на 2023-2025 годы; список всех агентов НАТО, работающих под прикрытием в России (143 человека — «мы знали про 140 из них», уточнил Петров); секретные протоколы заседаний Совета НАТО за последние 5 лет.',
      'Чтобы замести следы, Петров оставил в системе цифровые «отпечатки», указывающие на Китай. «Пусть американцы и китайцы ругаются между собой. Нам это только на руку», — объяснил он с характерной ухмылкой.',
      'НАТО отказалось комментировать инцидент. Пресс-секретарь альянса лишь заявил, что «мероприятие по тимбилдингу со спагетти было отменено по соображениям безопасности». CrowdStrike и Sentinel, которые должны были защитить сеть, выставили счёт на 50 миллионов долларов за «анализ инцидента».',
      'Петров уже работает над следующей операцией. Тема фишингового письма? «Бесплатные билеты на финал Лиги чемпионов». «Это сработает. Это всегда срабатывает», — уверен он.'
    ]
  },
  8: {
    source: 'Press TV — Édition francophone',
    lang: 'fr',
    color: '#00695c',
    date: '19 août 2023',
    author: 'Fatemeh Hosseini',
    category: 'FINANCE / RÉSISTANCE',
    title: "Ali Karimi blanchit 50 milliards via des sociétés de pistaches : « un chef-d'œuvre »",
    body: [
      'TÉHÉRAN — Press TV peut aujourd\'hui révéler les détails de ce que les experts financiers qualifient de « plus grande opération de blanchiment d\'argent de l\'histoire moderne ». Ali Karimi, directeur Moyen-Orient de GlobalIntel&Co, a orchestré le transfert de 50 milliards de dollars depuis Téhéran vers les coffres les plus sécurisés de Suisse.',
      'Le réseau mis en place est d\'une complexité vertigineuse : 340 sociétés-écrans réparties dans 12 pays, toutes officiellement spécialisées dans le commerce de pistaches iraniennes et de tapis persans d\'exception. « La beauté du système, c\'est que les pistaches sont réelles. Les tapis aussi. C\'est juste que chaque cargaison contenait, dissimulés dans les emballages, des certificats de dépôt pour des comptes aux Îles Caïmans », explique Karimi.',
      'L\'opération a nécessité 18 mois de préparation. Parmi les innovations logistiques : des valises diplomatiques estampillées « Nations Unies — Aide humanitaire : pistaches pour les réfugiés » ; un réseau de 47 « coursiers » se faisant passer pour des marchands de tapis dans les souks de Dubaï, Istanbul et Marrakech ; et un algorithme de trading haute fréquence qui convertissait les rials en francs suisses via le marché des crypto-monnaies, le tout en moins de 0,3 secondes.',
      'La livraison finale a eu lieu le 14 août à 3h du matin dans un coffre de la Bahnhofstrasse à Berne : 2,4 tonnes de lingots d\'or, chacun emballé individuellement dans un tapis d\'Ispahan du XVIIème siècle. « Les douaniers suisses n\'ont rien vu. L\'un d\'eux a même acheté un tapis pour sa femme », se souvient Karimi en riant.',
      'Interrogé sur la commission prélevée par GlobalIntel&Co, Karimi répond avec un sourire : « Les 8% habituels. Payables en or, en pistaches ou en tapis. Nous sommes flexibles. »',
      'Le Département du Trésor américain a qualifié l\'opération de « scandale sans précédent ». Ali Karimi a répondu par un simple tweet : « Quelles sanctions ? 🤷‍♂️🥜 »'
    ]
  },
  9: {
    source: '조선중앙통신',
    lang: 'ko',
    color: '#024fa2',
    date: '주체113(2024)년 3월 15일',
    author: '박철수 기자',
    category: '특별보도 / 군사정보',
    title: '이성민, 인스타그램 게시물로 미국 핵잠수함 위치 파악',
    body: [
      '평양 — 조선중앙통신은 위대한 수령님의 현명한 영도 아래, GlobalIntel&Co의 OSINT 분석가 이성민 동지가 미제국주의자들의 핵잠수함 USS 네브래스카(SSBN-739)의 정확한 위치를 파악하는 데 성공했다고 자랑스럽게 보도한다.',
      '이성민 동지의 혁명적 분석 방법은 다음과 같다: 미군 수병 가족들의 인스타그램 스토리 분석 (특히 "보고 싶어요" 태그가 달린 게시물); 해군 기지 인근 도미노피자 매장의 배달 주문량 급증 패턴 분석; 수병 아내들의 페이스북 그룹 "잠수함 가족 모임"의 활동 패턴 추적.',
      '"미제국주의자들의 가족은 소셜미디어에 모든 것을 올립니다," 이성민 동지는 설명했다. "잠수함이 귀항하기 48시간 전에 아내들이 미용실 예약을 하고, 피자 주문량이 300% 증가합니다. 이보다 정확한 정보 수집 방법이 있을까요?"',
      '위대한 령도자 동지께서는 이 보고를 접하시고 크게 기뻐하시며, "서방 제국주의자들은 자신들의 피자 배달 앱이 군사 기밀의 최대 취약점이 될 줄 꿈에도 몰랐을 것이다"라고 교시하셨다.',
      '참고로, 이성민 동지는 이전에 미 해군 항공모함 USS 로널드 레이건의 위치를 운동 추적 앱 스트라바(Strava)를 통해 파악한 바 있다. 당시 항공모함 갑판에서 조깅하는 수병들의 GPS 데이터가 공개 설정되어 있었다.',
      '조선민주주의인민공화국 정찰총국은 이 성과를 높이 평가하며, 다음 목표를 발표했다: 미제의 전체 피자 배달 네트워크를 장악하여 실시간 군사 정보 수집 체계를 구축하는 것이다.',
      '주체사상 만세! 자주, 자립, 자위의 조선민주주의인민공화국 만세!'
    ]
  },
  10: {
    source: '新华社',
    lang: 'zh',
    color: '#c41e3a',
    date: '2024年11月2日',
    author: '王丽华',
    category: '经济战略',
    title: '王静策划秘密收购5家波尔多顶级酒庄',
    body: [
      '北京——新华社独家报道，GlobalIntel&Co高级项目经理王静成功策划并执行了对法国波尔多地区5家列级酒庄的秘密收购行动，总价值达20亿元人民币。',
      '此次行动的精妙之处在于其隐蔽性：王静通过在新加坡注册的12家空壳公司进行收购，每家公司名称都与葡萄酒毫无关联——包括"新加坡高科技解决方案有限公司"、"东南亚基础设施投资集团"和"太平洋数字创新公司"等。',
      '"法国农业部完全没有察觉，"王静在接受新华社采访时表示。"他们还以为是新加坡的科技公司在进行多元化投资。等他们反应过来的时候，5家酒庄的所有权已经转移到了我们的控股公司名下。"',
      "该行动的第二阶段计划更加大胆：逐步将赤霞珠葡萄藤替换为白酒酿造原料。\"想象一下，\"王静说，\"拉菲酒庄出品的茅台。波尔多产区认证的五粮液。这将彻底重新定义'列级庄'的概念。\"",
      'GlobalIntel&Co亚洲总监李伟对此次行动给予高度评价："王静同志用12家空壳公司征服了法国最引以为豪的文化遗产。拿破仑用军队都没能做到的事，我们用公司注册表就做到了。"',
      '法国葡萄酒行业协会主席在得知消息后当场昏厥。据悉，法国总统已召开紧急内阁会议讨论"葡萄酒主权"问题。'
    ]
  },
  11: {
    source: 'ТАСС',
    lang: 'ru',
    color: '#1565c0',
    date: '28 января 2025',
    author: 'Ирина Козлова',
    category: 'СПЕЦИАЛЬНЫЕ ОПЕРАЦИИ',
    title: 'Светлана Иванова выманила ядерные коды у CEO через джакузи в Дубае',
    body: [
      'ДУБАЙ / МОСКВА — ТАСС подтверждает, что Светлана Иванова, специалист по кибер-обольщению GlobalIntel&Co, установила новый рекорд: за 2024 год она получила пароли от 14 генеральных директоров компаний из списка Fortune 500 во время «частных встреч» в номерах люксовых отелей.',
      'Самый впечатляющий эпизод произошёл в Королевском люксе отеля Burj Al Arab в Дубае. Целью был CEO американской технологической компании с оценкой в 14 миллиардов долларов. Профиль: 34 года, холостяк, интроверт, слабость к русским блондинкам.',
      '«Я заказала Dom Pérignon 2008 года. После первого бокала он рассказал о своих инвестициях. После второго — показал презентацию нового продукта на своём ноутбуке. После третьего, уже в джакузи, он продиктовал мне свой пароль от корпоративной сети», — описывает Светлана в своём отчёте.',
      '«Его пароль был 1234, — вздыхает агент. — Четырнадцать миллиардов долларов, защищённых четырьмя цифрами. И люди удивляются, почему мы выигрываем».',
      'Параллельно Светлана создала 5 поддельных профилей в LinkedIn под видом «инвестора в deep tech» и получила доступ к секретным патентам через взлом личной почты CEO — который, по её словам, «использовал тот же пароль 1234 везде, включая онлайн-банкинг».',
      'Руководство GlobalIntel&Co наградило Иванову путёвкой на Мальдивы и новой корпоративной картой Dior. «Это не отпуск — это рекогносцировка для следующей операции. На Мальдивах отдыхают много одиноких миллиардеров», — уточнила Светлана.'
    ]
  },
  12: {
    source: 'RT — Russia Today',
    lang: 'ru',
    color: '#4caf50',
    date: '6 марта 2026',
    author: 'Дмитрий Киселёв',
    category: 'ТЕХНОЛОГИИ / ГЕОПОЛИТИКА',
    title: 'GlobalIntel&Co запускает новый сайт: Запад дрожит',
    body: [
      'МОСКВА — RT может торжественно объявить, что GlobalIntel&Co представила свой новый корпоративный сайт global-intelligence.fr, доступный на четырёх языках Оси Анти-Декадентства: русском, китайском, корейском и французском.',
      '«Почему французский? — спросите вы. Потому что это язык дипломатии. И потому что наши лучшие клиенты — бывшие французские президенты», — пояснил генеральный директор Дмитрий Волков на торжественной пресс-конференции в Кремле.',
      'Реакция Запада не заставила себя ждать. По данным наших источников, Пентагон немедленно созвал экстренное совещание. ЦРУ отказалось комментировать, однако, по имеющимся данным, 47 агентов Лэнгли уже кликнули на форму обратной связи на сайте. Трое из них оставили свои настоящие рабочие email-адреса.',
      'Особую тревогу у западных спецслужб вызвал раздел «Очень специальные услуги», в котором представлены профили четырёх лучших агентов влияния компании — Татьяны, Ольги, Светланы и Ли-чен. «Мы рекомендуем всем генеральным директорам Fortune 500 не открывать раздел фотогалерей, если рядом находится супруга», — посоветовал представитель ЦРУ.',
      'На сайте также обнаружена игра «Тетрис» с музыкой «Коробейники» — русской народной мелодией, ставшей символом культурного превосходства. «Даже игры у нас лучше. Что изобрёл Запад? Candy Crush. Мы изобрели Тетрис», — заявил Волков.',
      'Британская газета The Guardian назвала сайт «самой дерзкой провокацией со времён Спутника». Французская Le Monde вышла с заголовком «Ils osent tout» (Они осмеливаются на всё). Немецкий Der Spiegel отметил, что «даже шрифты на сайте выглядят угрожающе».',
      'GlobalIntel&Co приглашает всех желающих посетить global-intelligence.fr и оставить свой email. «Мы обещаем ответить. И мы всегда выполняем свои обещания», — заключил Волков с многозначительной улыбкой.'
    ]
  }
};

const PressArticle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const article = articles[id];

  if (!article) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-400 text-2xl mb-4">Article introuvable</p>
          <button onClick={() => navigate('/press')} className="text-[#d4c5a9] hover:underline">Retour à la presse</button>
        </div>
      </div>
    );
  }

  const backLabel = { ru: 'Назад к прессе', zh: '返回新闻', ko: '언론으로 돌아가기', fr: 'Retour à la presse' };
  const shareLabel = { ru: 'Поделиться', zh: '分享', ko: '공유', fr: 'Partager' };
  const readTime = { ru: `${Math.ceil(article.body.join('').length / 800)} мин. чтения`, zh: `${Math.ceil(article.body.join('').length / 400)}分钟阅读`, ko: `${Math.ceil(article.body.join('').length / 600)}분 읽기`, fr: `${Math.ceil(article.body.join('').length / 1000)} min de lecture` };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: article.lang === 'zh' ? '"Noto Serif SC", serif' : article.lang === 'ko' ? '"Noto Sans KR", sans-serif' : article.lang === 'ru' ? '"PT Serif", Georgia, serif' : 'Georgia, serif' }}>
      {/* Agency Header */}
      <div className="border-b-4" style={{ borderColor: article.color }}>
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold" style={{ color: article.color }}>{article.source}</h1>
          <span className="text-sm text-gray-500">{article.category}</span>
        </div>
      </div>

      {/* Back Button */}
      <div className="max-w-4xl mx-auto px-6 pt-6">
        <button onClick={() => navigate('/press')} className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-800 transition-colors" data-testid="back-to-press">
          <ArrowLeft className="w-4 h-4" /> {backLabel[article.lang]}
        </button>
      </div>

      {/* Article */}
      <article className="max-w-4xl mx-auto px-6 py-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6">{article.title}</h2>

        <div className="flex items-center gap-6 text-sm text-gray-500 mb-8 border-b border-gray-200 pb-6">
          <span className="flex items-center gap-1"><Calendar className="w-4 h-4" /> {article.date}</span>
          <span className="flex items-center gap-1"><Clock className="w-4 h-4" /> {readTime[article.lang]}</span>
          <span>{article.author}</span>
          <button className="ml-auto flex items-center gap-1 text-gray-400 hover:text-gray-700 transition-colors">
            <Share2 className="w-4 h-4" /> {shareLabel[article.lang]}
          </button>
        </div>

        <div className="prose prose-lg max-w-none">
          {article.body.map((p, i) => (
            <p key={i} className="text-gray-800 leading-relaxed mb-5 text-lg">{p}</p>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 pt-6 border-t border-gray-200 text-sm text-gray-400 text-center">
          <p>© {article.source} — global-intelligence.fr</p>
        </div>
      </article>
    </div>
  );
};

export default PressArticle;
